(function () {
    'use strict';

    angular
        .module('app')
        .controller('DeleteTagDialogCtrl', DeleteTagDialogCtrl);

    DeleteTagDialogCtrl.$inject = ['DialogInstance', 'TagsService', 'tagIds'];

    /**
     * @ngdoc Controller
     * @description
     * Dialog prompting the user for confirmation they wish to delete a tag.
     * Tag usage will also be shown.
     * 
     * @param {int} tagIds - Ids of tags that are to be deleted.
     */
    function DeleteTagDialogCtrl(DialogInstance, TagsService, tagIds) {
        /* jshint validthis:true */
        var vm = this;
        vm.loading = true;
        vm.ok = ok;
        vm.cancel = cancel;
        Object.defineProperty(vm, 'confirmMessage', {
            get: function () {
                return tagIds.length > 1 ? ('Delete the ' + tagIds.length + ' selected Tags?') : 'Delete the Tag?';
            }
        });

        activate();

        function activate() {
            getUsage().finally(function () {
                vm.loading = false;
            });
        }

        function getUsage() {
            return TagsService.getLinkedItems(tagIds).then(function (linkedItems) {
                vm.linkedItems = linkedItems;
            }, function (response) {
                if (response.status === 404) {
                    vm.tagNotFound = true;
                }

                vm.error = true;
            });
        }

        function ok() {
            if (vm.tagNotFound) {
                DialogInstance.cancel();
            }

            DialogInstance.ok();
        }

        function cancel() {
            DialogInstance.cancel();
        }
    }
})();
